export const initialState = {
  createdAt: "",
  deepLink: "",
  email: "",
  hasCustomScript: false,
  hasReviewed: false,
  hasProducts: false,
  hasCustomerExperiences: false,
  id: null,
  isAtRiskOfBadReview: false,
  isEnabled: false,
  isInstalled: false,
  isOnboarded: false,
  locale: "en",
  name: null,
  phone: null,
  shopifyPlan: null,
  scriptVersion: null,
  shopifyDomain: null,
  updatedAt: null,
  deletedAt: null,
  accessToken: null,
  customDomain: {
    error: null,
    status: "pending",
    email: "",
    dnsRecords: [],
  },
  subscription: {
    subscriptionPlan: "STANDARD",
    subscriptionPriceOption: "FREE",
    subscriptionVersion: 1,
    hasAddOn: false,
    hasUnlimitedOrders: false,
    numberOfOrders: 0,
    numberOfOrdersUsed: 0,
    lifetimeOrderLimit: 20,
    lifetimeOrdersUsed: 0,
    pricePaid: 0,
  },
};
